//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            tabs: ['扫码登录', '密码登录', '验证码登录'],
            code: '',
            phone: '',
            pass: '',
            qrcodeShow: false,
            inputType: 'password',
            eyeShow: false,
            loginType: 0, // 1:密码登录，2:验证码登录, 0:扫码登录
            checkBox: false, // 判断是否选中三天内自动登录 true 为选中
            startInterval: '',
            qrcode: '',
            sendShow: true,
            timers: 0
        }
    },
    created() {
        this.qrcodeLogin()
    },
    // 先判断是不是扫码登录（即qrcodeShow 是否为true），不是的话再判断loginType，1密码登录，2验证码登录
    methods: {
        tabChange (index) {
            this.loginType = index
            if (index === 0) {
                this.qrcodeLogin()
            } else {
                clearInterval(this.startInterval)
            }
        },
        qrcodeLogin() {
            // this.qrcodeShow = !this.qrcodeShow
            // let that = this
            // if (this.qrcodeShow === true) {
            //     this.loginType = 3
            //     clearInterval(this.startInterval)
            //     let code = Date.parse(new Date()) / 1000
            //     this.qrcode = 'https://psapi.51sssong.com/admin/smLogin?code=' + code
            //     this.startInterval = setInterval(function () {
            //         that.smLoginInfo(code)
            //     }, 4000)
            // } else {
            //     this.loginType = 2
            //     clearInterval(this.startInterval)
            // }
            let _this = this
            clearInterval(this.startInterval)
            let code = Date.parse(new Date()) / 1000
            // this.qrcode = 'https://psapi.51sssong.com/admin/smLogin?code=' + code
            this.qrcode = 'https://psapi.songjianxia.com/admin/smLogin?code=' + code
            this.startInterval = setInterval(function () {
                _this.smLoginInfo(code)
            }, 4000)
        },
        passShow(flag) {
            if (flag === 1) {
                this.inputType = 'text'
                this.eyeShow = true
            } else {
                this.inputType = 'password'
                this.eyeShow = false
            }
        },
        selectBox() {
            this.checkBox = !this.checkBox
        },
        loginSubmit() {
            if (this.loginType !== 0) {
                if (!this.phone) {
                    this.$toast('手机号不能为空')
                    return false
                }
                if (this.loginType === 1) {
                    if (!this.pass) {
                        this.$toast('密码不能为空')
                        return false
                    }
                } else if (this.loginType === 2) {
                    if (!this.code) {
                        this.$toast('验证码不能为空')
                        return false
                    }
                }
            }

            // if (this.loginType === 1 && this.pass === 'songjianxia') {
            //     global.special = 1
            //     sessionStorage.setItem('special', 1)
            // } else {
            //     global.special = 0
            //     sessionStorage.setItem('special', 0)
            // }
            // global.HTTP = global.special === 0 ? 'https://psapi.songjianxia.com/admin/v2/' : 'https://psapi.51sssong.com/admin/v2/'

            let that = this
            let param = {
                user_tel: this.phone,
                code: this.code,
                password: this.pass,
                loginType: this.loginType,
                auto: this.checkBox === true ? 1 : 0
            }
            this.$http
                .post(global.HTTP + 'login/login', param)
                .then(function (resp) {
                    if (resp.data.code === 0) {
                        sessionStorage.setItem('hasExportXlsxPermission', resp.data.data.new_export)

                        let marker = 0
                        if (resp.data.data.llw === 1) {
                            marker = 1
                        }
                        sessionStorage.setItem('marker', marker)

                        let day = 1
                        if (that.selectBox === true) day = 3
                        sessionStorage.setItem('token', resp.data.data.token)
                        sessionStorage.setItem('gtoken', resp.data.data.gtoken)
                        sessionStorage.setItem('phone', that.phone)

                        global.ratio = resp.data.data.ratio ? resp.data.data.ratio : 1
                        // console.log(resp.data.data.ratio, 9999)
                        sessionStorage.setItem('ratio', global.ratio)

                        sessionStorage.setItem('tourist', resp.data.data.tourist)

                        that.$role.saveCookies(resp.data.data.user, day)
                        that.$role.saveGlobal(resp.data.data.user)
                        
                        let menus = resp.data.data.menus

                        let hideUrl = {
                            component: "none",
                            icon: null,
                            id: 999,
                            is_hidden: 1,
                            is_leaf: 0,
                            menu_id: 15,
                            name: "区域共享门店业绩",
                            path: "/shareOrders"
                        }

                        menus.forEach(item => {
                            if (item.id == 15 && ( resp.data.data.user.id == 108 || resp.data.data.user.id == 52 || resp.data.data.user.id == 115)) {
                                item.children.push(hideUrl)
                            }
                        });

                        that.$role.setRoleMenu(menus)
                        that.$role.orderSource()
                        that.$role.sellerList()
                        that.$role.agentList()
                        that.$role.regionList()
                        that.$role.agentLevel()
                        that.$role.orderDelivery()
                        // orderList
                        if (!resp.data.data.user.password) {
                            that.$router.push('setPass')
                        } else if (resp.data.data.tourist == 1) {
                            that.$router.push('merchantList')
                        } else {
                            that.$router.push('index')
                        }
                    } else {
                        that.$toast(resp.data.msg)
                    }
                })
                .catch(function (err) {
                    console.log(err)
                })
        },
        smLoginInfo(code) {
            console.log(code)
            let that = this
            let param = {
                code: code
            }
            this.$http
                .post(global.HTTP + 'login/smLoginInfo', param)
                .then(function (resp) {
                    if (resp.data.code === 0) {
                        clearInterval(that.startInterval)
                        if (resp.data.data.user) {
                            sessionStorage.setItem('token', resp.data.data.token)
                            global.ratio = resp.data.data.ratio ? resp.data.data.ratio : 1
                            // console.log(resp.data.data.ratio, 9999)
                            sessionStorage.setItem('ratio', global.ratio)
                            sessionStorage.setItem('tourist', resp.data.data.tourist)
                            that.$role.saveCookies(resp.data.data.user, 1)
                            that.$role.saveGlobal(resp.data.data.user)

                            let menus = resp.data.data.menus

                            let hideUrl = {
                                component: "none",
                                icon: null,
                                id: 999,
                                is_hidden: 1,
                                is_leaf: 0,
                                menu_id: 15,
                                name: "区域共享门店业绩",
                                path: "/shareOrders"
                            }

                            menus.forEach(item => {
                                if (item.id == 15 && ( resp.data.data.user.id == 108 || resp.data.data.user.id == 52 || resp.data.data.user.id == 115)) {
                                    item.children.push(hideUrl)
                                }
                            });

                            that.$role.setRoleMenu(menus)
                            that.$role.orderSource()
                            that.$role.sellerList()
                            that.$role.agentList()
                            that.$role.regionList()
                            that.$role.agentLevel()
                            that.$role.orderDelivery()
                            if (!resp.data.data.user.password) that.$router.push('setPass')
                            else that.$router.push('index')
                        } else {
                            that.$router.push({
                                path: 'bdPhone',
                                query: {
                                    unionid: resp.data.data.unionid
                                }
                            })
                        }
                    } else {
                        // that.$toast(resp.data.msg)
                    }
                })
                .catch(function (err) {
                    console.log(err)
                })
        },
        sendCode() {
            this.timers = 60
            let that = this
            let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
            if (!myreg.test(this.phone)) {
                this.$toast('请检查手机号码')
                return false
            } else {
                this.sendShow = false
                let param = {
                    phone: this.phone
                }
                this.$http
                    .post(global.HTTPMobile + '/delivery/send/sms', param)
                    .then(function (resp) {
                        if (resp.data.code === 0) {
                            that.sendShow = false
                            that.timers = 60
                            let t = setInterval(function () {
                                that.timers = --that.timers
                                if (that.timers === 0) {
                                    that.timers = 0
                                    clearInterval(t)
                                    that.sendShow = true
                                }
                            }, 1000)
                        } else {
                            that.sendShow = true
                            that.$toast(resp.data.msg)
                        }
                    })
                    .catch(function (err) {
                        console.log(err)
                    })
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Admin/login/login.vue